module.exports = __webpack_public_path__ + "img/slowcar.be456e3f.png";